import { IotaClient } from '@iota/iota-sdk/client';
import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { DECIMALS, Env } from 'modules/common';

import { getConfig } from '../const/getConfig';

interface IGetBalanceParams {
  walletAccount: WalletAccount;
  client: IotaClient;
  env: Env;
}

export interface IGetBalancesResult {
  native: BigNumber;
  staked: BigNumber;
}

export async function getBalances({
  walletAccount,
  client,
  env,
}: IGetBalanceParams): Promise<IGetBalancesResult> {
  const config = getConfig(env);

  const native = await client.getBalance({
    owner: walletAccount.address,
    coinType: config.stake.token,
  });

  const staked = await client.getBalance({
    owner: walletAccount.address,
    coinType: config.unstake.token,
  });

  return {
    native: new BigNumber(native.totalBalance).div(DECIMALS),
    staked: new BigNumber(staked.totalBalance).div(DECIMALS),
  };
}
